import PropTypes from "prop-types";
import styles from "./styles.module.css";

const ModalTitle = ({ title, subTitle, tabs, actions, closeModal }) => {
  return (
    !!title && (
      <div
        className={`${styles["modal-title-wrapper"]} ${
          !tabs && styles["border-bottom"]
        }`}
      >
        <div className={styles["modal-title-text-wrapper"]}>
          <div className={styles["modal-title-text"]}>{title}</div>
          {!!subTitle && (
            <div className={styles["modal-sub-title-text"]}>{subTitle}</div>
          )}
        </div>
        <div className={styles["modal-header-actions"]}>
          {actions}
          <button
            type="button"
            onClick={closeModal}
            aria-label="Close modal"
            className={`btn btn-link p-0 border-0 bg-transparent`}
          >
            <img src="/ui/images/Truman-UI-Modal-Close.svg" alt="" />
          </button>
        </div>
      </div>
    )
  );
};

ModalTitle.propTypes = {
  title: PropTypes.node,
  subTitle: PropTypes.node,
  tabs: PropTypes.node,
  actions: PropTypes.node,
  closeModal: PropTypes.func,
};

export default ModalTitle;
